<template>
  <b-row class="match-height followup-tab">
    <b-col md="12">
      <major ref="major"></major>
    </b-col>
    <b-col md="12">
      <reintervention ref="reintervention"></reintervention>
    </b-col>
    <b-col cols="12">
      <echo ref="echo"></echo>
    </b-col>
    <b-col md="4">
      <lab ref="lab"></lab>
    </b-col>
    <b-col md="8">
      <clinical ref="clinical"></clinical>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard } from "bootstrap-vue";
import Major from "./followup/Major";
import Reintervention from "./followup/Reintervention";
import Lab from "./followup/Lab";
import Clinical from "./followup/Clinical";
import Echo from "./followup/Echo";
import { mapState, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import config from "@/config";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    Major,
    Reintervention,
    Lab,
    Clinical,
    Echo,
  },
  timers: { updatePatient: config.TIMER_OPTION },
  computed: {
    ...mapState("patient", ["patient", "role"]),
    readOnly() {
      return this.role == "viewer" || this.role == "";
    },
  },
  methods: {
    ...mapActions("patient", ["updatePatientById"]),
    updatePatient() {
      if (this.readOnly) {
        return;
      }

      let activeElement = document.activeElement;
      let blockingElements = ["input", "textarea"];
      let isFlatPickrInput =
        activeElement && activeElement.classList.contains("flatpickr-input");

      // check whether an input field is the active elemnent,
      //if it is, do not interrupt the users entries with updating
      // the patientInfo but return instead
      if (
        activeElement &&
        blockingElements.indexOf(activeElement.tagName.toLowerCase()) !== -1 &&
        !isFlatPickrInput // still save, if the active element is a flatpickr element and thus a date field
      ) {
        return;
      }

      let patientInfo = {
        ...this.$refs.major.patientInfo,
        ...this.$refs.reintervention.patientInfo,
        ...this.$refs.echo.patientInfo,
        ...this.$refs.lab.patientInfo,
        ...this.$refs.clinical.patientInfo,
      };

      this.updatePatientById(patientInfo).catch((err) => {
        this.showToast(
          "danger",
          "Error",
          "An error occured while updating the patient."
        );
      });
    },
    showToast(variant, title, content) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: "BellIcon",
          text: content,
          variant,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.followup-tab {
  .vertical-align {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  .bordered-card {
    border: 1px solid rgba(34, 41, 47, 0.125);
  }
}
</style>
